import { tt } from "../../../../../utils/i18n/i18n";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../../../designsystem/KC_Button/KC_Button";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { CreateAnimationStep } from "../../../../../components/modal/ConfigAnimationModal/CreateAnimationModal";
import EventSection from "../EventSection";
import React, { useMemo } from "react";
import { ActiveEvent } from "kadow-jetpack-model/src";
import DashedCard from "../../../../../components/DashedCard/DashedCard";
import { GameConfig } from "kadow-jetpack-model";
import GameSection from "../GameSection";
import KC_Heading2 from "../../../../../designsystem/typography/KC-Heading/KC_Heading2";

interface Props {
  games: GameConfig[];
  permanentEvent: ActiveEvent[];
  ephemeralEvents: ActiveEvent[];
  showCreateAnimationModal: (step: CreateAnimationStep) => Promise<void>;
  canUseGamesOfChance: boolean;
  canUsePerformanceGames: boolean;
}

export default function (props: Props) {
  const canAdd = useMemo(() => {
    return props.canUseGamesOfChance || props.canUsePerformanceGames;
  }, [props.canUseGamesOfChance, props.canUsePerformanceGames]);

  const showDashedAddButton = useMemo(() => {
    return (
      !props.ephemeralEvents.length &&
      !props.games.length &&
      !props.permanentEvent.length &&
      (props.canUseGamesOfChance || props.canUsePerformanceGames)
    );
  }, [
    props.ephemeralEvents,
    props.games,
    props.permanentEvent,
    props.canUseGamesOfChance,
    props.canUsePerformanceGames
  ]);

  function addNew() {
    void props.showCreateAnimationModal(CreateAnimationStep.EventConfig);
  }

  function renderAddButton() {
    if (!canAdd) {
      return null;
    }

    return (
      <>
        <KC_Button
          id="add-ephemeral-game"
          size={KC_ButtonSize.Large}
          showIconOnTheLeft={true}
          icon={faPlus}
          onClick={addNew}
          isPrimary
          text={tt("add_button")}
          className="d-none d-sm-flex"
          extraStyle={{
            width: "unset !important"
          }}
        />
        <KC_Button
          id="add-ephemeral-game-mobile"
          size={KC_ButtonSize.Medium}
          showIconOnTheLeft={true}
          icon={faPlus}
          onClick={() => {
            void props.showCreateAnimationModal(
              CreateAnimationStep.EventConfig
            );
          }}
          isPrimary
          text={tt("add_button")}
          className="d-flex d-sm-none"
          extraStyle={{
            width: "unset !important"
          }}
        />
      </>
    );
  }

  function renderHeader() {
    return (
      <div className="d-flex flex-row align-items-center w-100 gap-sm">
        <KC_Heading2 text={tt("your_animation")} className="flex-grow-1" />
        {!showDashedAddButton && renderAddButton()}
      </div>
    );
  }

  return (
    <div
      id="game-and-events-section"
      className="px-4 pt-5 d-flex flex-column st-gap"
      style={{ marginBottom: 40 }}
    >
      <div className="w-100 d-flex justify-content-start">
        <div className="d-flex flex-column flex-grow-1 justify-content-center gap-sm">
          {renderHeader()}
        </div>
      </div>

      {canAdd && showDashedAddButton && (
        <DashedCard>
          <KC_Button
            type={KC_ButtonType.Button}
            size={KC_ButtonSize.Large}
            isPrimary={true}
            showIconOnTheLeft={true}
            icon={faPlus}
            onClick={addNew}
            text={tt("create_first_animation")}
            className="d-flex"
          />
        </DashedCard>
      )}
      <GameSection
        displayGame={{
          games: props.games,
          activeEvents: props.permanentEvent
        }}
      />
      <EventSection activeEvents={props.ephemeralEvents} />
    </div>
  );
}
